import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69cae91ec3f8480013df456f/drivenmarket/src/app/resources/page.tsx");
